<template>
  <div class="content">
    
    <!-- 商品表格 -->
    <div style="height:80%">
      <el-table
        :data="beforArr"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        :header-cell-style="{background:'#e8effc', color:'#000'}"
      >
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column label="用户id" width="80" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.userId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.phone}}</span>
          </template>
        </el-table-column>
        <el-table-column label="留言" width="350" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.wechat}}</span>
          </template>
        </el-table-column>
        <el-table-column label="日期" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.createTime}}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <!-- <el-button size="mini" @click="ejectupdataGoods(scope.row)">修改</el-button> -->
            <el-button size="mini" type="danger" @click="deleteAdmin(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { selectApply, deleteApply } from "@/services/input";
export default {
  data() {
    return {
      beforArr: [],
      inputTitle: "开户",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: "0" },
        { name: "普通子账号权限", id: "1" }
      ],
      form: {},
      dialogFormVisible: false
    };
  },
  created() {
    // 查询用户登陆数据
    this.selece();
  },
  methods: {
    // 查询
    selece() {
      selectApply().then(resp => {
        console.log(resp);
        this.loading = false;
        this.beforArr = resp;
        // this.$message({
        //   type: "success",
        //   message: "跟新成功!"
        // });
        // this.pageCount = resp.pageCount;
      });
    },
    // 开户按钮
    kaihuBtn() {
      this.inputTitle = "开户";
      this.dialogFormVisible = true;
      this.form = {};
    },
    ejectupdataGoods(row) {
      console.log(row);
      this.dialogFormVisible = true;
      this.inputTitle = "修改";
      this.form = row;
    },
    // 表单提交按钮
    sumbmitBtn() {
      console.log(this.form);
      if (this.form.sup_username == "" || this.form.sup_username == null) {
        this.$message.error("请填写用户名");
        return;
      }
      if (this.form.sup_password == "" || this.form.sup_password == null) {
        this.$message.error("请填写密码");
        return;
      }
      if (this.form.supplier_phone == "" || this.form.supplier_phone == null) {
        this.$message.error("请填写手机号");
        return;
      }
      if (this.form.role_id == null) {
        this.$message.error("请选择权限");
        return;
      }
      if (this.form.message == "" || this.form.message == null) {
        this.$message.error("请填写备注");
        return;
      }
      if (this.inputTitle == "开户") {
        return;
      }
      this.$message({
        type: "success",
        message: "修改账号接口正在紧急安装中!"
      });
    },
    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deleteApply(row.id).then(resp => {
            console.log(resp);
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.selece();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>